(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /*
    Remove only the visible "Sale" badge.
    Other future badges such as "Sold out" remain untouched.
  */
  const removeSpotlySaleBadges = (root = document) => {
    root.querySelectorAll('.spotly-collection .product-badges__badge').forEach((badge) => {
      if (badge.textContent.trim().toLowerCase() === 'sale') {
        badge.remove();
      }
    });

    root.querySelectorAll('.spotly-collection .product-badges').forEach((wrapper) => {
      if (!wrapper.querySelector('.product-badges__badge')) {
        wrapper.remove();
      }
    });
  };

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      removeSpotlySaleBadges();

      const collection = document.querySelector('.spotly-collection');

      if (collection) {
        const observer = new MutationObserver(() => {
          removeSpotlySaleBadges(collection);
        });

        observer.observe(collection, {
          childList: true,
          subtree: true
        });
      }
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
